import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

// Navigation Component
const Navigation = ({ activeSection, scrollToSection, isScrolled }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-slate-900/95 backdrop-blur-md shadow-2xl border-b border-emerald-500/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-400 via-blue-500 to-yellow-500 rounded-xl flex items-center justify-center shadow-xl transform hover:rotate-6 transition-transform duration-300">
                <span className="text-white font-black text-xl">KM</span>
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full animate-pulse"></div>
            </div>
            <div>
              <h1 className="text-white font-bold text-xl bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent">
                Kuba Meridian
              </h1>
              <p className="text-yellow-400 text-sm font-medium">
                Group Holding
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {["home", "about", "subsidiaries", "values", "news", "contact"].map(
              (section) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className={`relative text-white hover:text-yellow-400 transition-all duration-300 font-medium capitalize group ${
                    activeSection === section ? "text-yellow-400" : ""
                  }`}
                >
                  {section}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-emerald-400 group-hover:w-full transition-all duration-300"></span>
                </button>
              )
            )}
            <button
              onClick={() => scrollToSection("contact")}
              className="bg-gradient-to-r from-emerald-500 via-blue-500 to-yellow-500 hover:from-yellow-500 hover:via-emerald-500 hover:to-blue-500 text-white px-6 py-3 rounded-full font-bold text-sm transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl border border-white/20"
            >
              Get Started
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2 rounded-lg hover:bg-white/10 transition-colors"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden bg-slate-900/98 backdrop-blur-md py-6 space-y-3 border-t border-emerald-500/20">
            {["home", "about", "subsidiaries", "values", "news", "contact"].map(
              (section) => (
                <button
                  key={section}
                  onClick={() => {
                    scrollToSection(section);
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left px-6 py-3 text-white hover:text-yellow-400 hover:bg-white/5 transition-all capitalize font-medium rounded-lg"
                >
                  {section}
                </button>
              )
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
